<template>
<PageWithHeader use-footer>
  <template #title>
    <t path="settings_2">Settings</t>
  </template>

  <div class="setting pt-24 f-md px-16">
    <div class="menu df-middle">
      <t path="settings_3" class="flex-1">Avatar</t>
      <TheAvatar :avatar="avatar || ''" class="avatar" />
    </div>
    <Line />
    <router-link to="/me/setting/nick" class="menu df-middle">
      <t path="settings_4" class="flex-1">NickName</t>
      <span class="f-nm f-medium">{{nickName}}</span>
      <Icon name="caret-right" class="f-nm" />
    </router-link>
    <Line />
    <div class="menu df-middle">
      <t path="settings_5" class="flex-1">Account</t>
      <span class="f-nm c-tip f-medium">{{account}}</span>
    </div>
    <Line />
    <div class="menu df-middle">
      <t path="settings_10" class="flex-1">Mobile Number</t>
      <span class="f-nm c-tip f-medium">{{mobile}}</span>
    </div>
    <Line />
    <router-link to="/reset" class="menu df-middle">
      <t path="settings_6" class="flex-1">Set Password</t>
      <Icon name="caret-right" class="f-nm" />
    </router-link>
    <Line />
<!--    <TheSettingItem />-->
<!--    <Line />-->
    <div class="menu df-middle" v-if="islamFlag">
      <t path="settings_11" class="c-tip">Islamic Account (Swap Free)</t>
    </div>
    <Line v-if="islamFlag" />
  </div>

  <template #footer>
    <button class="btn line signOut" @click="$emit('close', logOut)">
      <t path="settings_9" #="{td}" custom>{{td || 'Sign out'}}</t>
    </button>
  </template>
</PageWithHeader>
</template>

<script lang="ts">
import { syncLogout } from '@/modules/user/user'
import { localGet } from 'essential/store/localStore'
import { keymap } from '@/config'
import TheAvatar from '@/pages/setting/components/TheAvatar.vue'
import { defineComponent } from 'vue'
import PageWithHeader from '@/provider/PageWithHeader.vue'
import Icon from '@/components/Icon.vue'
import Line from '@/components/Line.vue'
import TheSettingItem from '@/features/fbLogin/TheSettingItem.vue'

export default defineComponent({
  name: 'Setting',
  components: { Line, Icon, PageWithHeader, TheAvatar },
  setup () {
    return {
      nickName: localGet(keymap.user.nickName),
      account: localGet(keymap.user.accountNum),
      mobile: localGet(keymap.user.mobile),
      islamFlag: Boolean(Number(localGet(keymap.user.islamFlag))) || false,
      logOut: syncLogout,
      avatar: localGet(keymap.user.avatar),
    }
  },
})
</script>

<style scoped lang="scss">
.signOut {
  width: 120px;
}

.controls {
  .line::after {
    border-color: var(--color-tip);
  }
}

.menu {
  height: 48px;
}

.setting .line::after {
  border-color: var(--color-grey);
}

.avatar {
  width: 32px;
  height: 32px;
  overflow: hidden;
  border-radius: 50%;
}

</style>
